import State from '../interfaces/states/State';

import * as moment from 'moment';

import { createSelector } from 'reselect';

const getMonthActivityArray = createSelector(
  (state: State) => state.activity.activityData,
  (state: State) => state.activity.currentYear,
  (activityData, currentYear): number[] => {
    // tslint:disable-next-line:triple-equals
    if (activityData.dates && activityData.dates.length != 0) {
      return activityData.dates.filter((item) => {
        // tslint:disable-next-line:triple-equals
        return moment(item).format('YYYY') == currentYear;
      }).map((month) => {
        return Number(moment(month).format('MM')) - 1;
      });
    } else {
      return null;
    }
  }
);

export default getMonthActivityArray;
